<template>
  <v-card elevation="0">
    <v-card-title class="pl-0"
      ><v-btn
        @click="$router.back()"
        color="secondaryAction"
        height="4em"
        class="rounded-lg pa-0 mr-4"
        ><v-icon color="white">mdi-chevron-left</v-icon></v-btn
      >
      {{ $t("register.endUserLicenseAgreement") }}</v-card-title
    >
    <v-container>
      <v-row>
        <v-sheet class="text-left" style="max-height: 350px; overflow-y: auto" v-html="$t('eula')">
        </v-sheet>
      </v-row>
      <v-row class="mt-5">
        <v-col
          ><v-btn elevation="0" block color="secondaryBackground">{{
            $t("register.decline")
          }}</v-btn></v-col
        >
        <v-col
          ><v-btn :loading="getInProgress" elevation="0" block @click="register" color="primary">{{
            $t("register.acceptTheTerms")
          }}</v-btn></v-col
        >
      </v-row>
    </v-container>
    <v-snackbar v-model="getInProgress" timeout="-1">
      <h3> {{ $t('register.completingYourRegistration') }} </h3>
      <v-progress-linear
        indeterminate
        class="mt-3"
        color="primaryAction darken-2"
      ></v-progress-linear>
    </v-snackbar>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters("auth/registration", ["getInProgress", "getSuccess"]),
  },
  methods: {
    ...mapActions("auth/registration", ["register"]),
  },
  watch: {
    getSuccess(newValue) {
      if (newValue) {
        this.$router.push("/auth/register/verification");
      }
    },
  },
};
</script>
